import { $FixMe } from '@eventbrite/ts-utils';
import loadable from '@loadable/component';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { FOLLOWED_ORGS_FILTER_VALUE } from '../../../../constants/filters';
import {
    handleRemoveAllFilters as handleRemoveAllFiltersAction,
    handleRemoveFilter as handleRemoveFilterAction,
    handleRemoveOnlineFilter as handleRemoveOnlineFilterAction,
} from '../../../../redux/actions/search';
import { openCloseAnimatedDrawer as openCloseAnimatedDrawerAction } from '../../../../redux/actions/ui';
import {
    getSelectedCategory,
    getSelectedDate,
    getSelectedFormat,
} from '../../../../redux/selectors/search';
import { DiscoverState, EventSearch } from '../../../../types';
import {
    FilterHeaderPills,
    FilterHeaderProps,
} from '../../components/FilterHeader/FilterHeaderPills';

const BotFilters = loadable(() => import('../../components/BotFilters'), {
    resolveComponent: (component: { BotFilters: React.ReactNode }) =>
        component.BotFilters,
});

import { gettext } from '@eventbrite/i18n';
import { useCurrentSearchOrganicEvents } from '../../SearchPageData';
import './FilterHeaderContainer.scss';

export type FilterHeaderContainerProps = Omit<
    FilterHeaderProps,
    'hashedEventTitle'
> & { eventSearch: EventSearch };

export const FilterHeader = (props: FilterHeaderContainerProps) => {
    const {
        handleRemoveFilter,
        selectedCategory,
        selectedPrice,
        selectedDate,
        selectedFormat,
        selectedLanguage,
        selectedCurrency,
        selectedOrganizations,
        followedOrganizers,
        isOnline,
        handleRemoveOnlineFilter,
        handleRemoveAllFilters,
        selectedHash,
        eventSearch,
        hideActiveFilterLabel,
        openCloseAnimatedDrawer,
        isBotRequest,
        locationSlug,
    } = props;

    const hashedEventTitle = useHashedEventTitle(eventSearch);

    const filterHeaderProps: FilterHeaderProps = {
        handleRemoveFilter: handleRemoveFilter,
        selectedPrice: selectedPrice,
        selectedDate: selectedDate,
        selectedFormat: selectedFormat,
        selectedLanguage: selectedLanguage,
        selectedCurrency: selectedCurrency,
        followedOrganizers: followedOrganizers,
        isOnline: isOnline,
        selectedCategory: selectedCategory,
        handleRemoveOnlineFilter: handleRemoveOnlineFilter,
        selectedOrganizations: selectedOrganizations,
        handleRemoveAllFilters: handleRemoveAllFilters,
        hashedEventTitle,
        selectedHash: selectedHash,
        hideActiveFilterLabel: hideActiveFilterLabel,
        openCloseAnimatedDrawer: openCloseAnimatedDrawer,
    };

    return (
        <>
            {isBotRequest ? (
                <span className="filter-header-container__mobile">
                    <BotFilters slug={locationSlug} />
                </span>
            ) : (
                <span className="filter-header-container filter-header-container__mobile">
                    <FilterHeaderPills
                        {...filterHeaderProps}
                        shouldRenderInactivePills={
                            props.shouldRenderInactivePills !== undefined
                                ? props.shouldRenderInactivePills
                                : true
                        }
                    />
                </span>
            )}

            <span className="filter-header-container filter-header-container__desktop">
                <FilterHeaderPills
                    {...filterHeaderProps}
                    shouldRenderInactivePills={
                        props.shouldRenderInactivePills !== undefined
                            ? props.shouldRenderInactivePills
                            : false
                    }
                />
            </span>
        </>
    );
};

const _mapStateToProps = (state: DiscoverState) => ({
    selectedPrice: state.search.eventSearch.price,
    isBotRequest: state.app.isBotRequest,
    locationSlug: state.location.slug,
    selectedCategory: getSelectedCategory(state.search.eventSearch.tags),
    selectedFormat: getSelectedFormat(state.search.eventSearch.tags),
    selectedDate: getSelectedDate(
        state.search.eventSearch.dates,
        state.search.eventSearch.dateRange,
    ),
    selectedCurrency:
        state.search.eventSearch.currencies.length > 0
            ? state.search.eventSearch.currencies[0]
            : '',
    selectedLanguage:
        state.search.eventSearch.languages.length > 0
            ? state.search.eventSearch.languages
            : '',
    followedOrganizers: state.search.eventSearch?.special?.includes(
        FOLLOWED_ORGS_FILTER_VALUE,
    ),
    selectedOrganizations: state.search.eventSearch.organizationsOr?.length
        ? state.search.eventSearch.organizationsOr
        : undefined,
    isOnline: state.search.eventSearch.onlineEventsOnly,
    selectedHash: state.search.eventSearch.hash,
    eventSearch: state.search.eventSearch,
});

function useHashedEventTitle(eventSearch: EventSearch) {
    const currentEvents = useCurrentSearchOrganicEvents(eventSearch);
    if (!eventSearch.hash) {
        return '';
    }

    return currentEvents[0]?.name || gettext('this event');
}

const _mapDispatchToProps = (
    dispatch: Function,
    ownProps: { history?: object },
) => ({
    handleRemoveFilter: (...args: [$FixMe]) =>
        dispatch(handleRemoveFilterAction(ownProps.history || {}, ...args)),
    handleRemoveOnlineFilter: (...args: [$FixMe]) =>
        dispatch(
            handleRemoveOnlineFilterAction(ownProps.history || {}, ...args),
        ),
    handleRemoveAllFilters: (...args: [$FixMe]) =>
        dispatch(handleRemoveAllFiltersAction(ownProps.history || {}, ...args)),
    openCloseAnimatedDrawer: (...args: [$FixMe]) =>
        dispatch(openCloseAnimatedDrawerAction(...args)),
});

const enhance = compose<any>(
    withRouter,
    connect(_mapStateToProps, _mapDispatchToProps),
);

export const FilterHeaderContainer = enhance(FilterHeader);
